import { CAROUSEL_FILES, carouselRelativePath } from "@/config/carousel";
import { assetUrl } from "@/utils/backend";
import { thumbUrl } from "@/utils/thumb";
import { enqueueImageLoad } from "@/utils/imageLoadQueue";

/** 首页/英文页轮播：Nginx 静态 URL，先缩略图背景，空闲后换高清 */
export const heroCarouselMixin = {
  data(): {
    carouselIndex: number;
    heroBgUrl: string;
    carouselTimer: ReturnType<typeof setInterval> | null;
    heroLoadGen: number;
    _heroDestroyed: boolean;
    _heroPendingIdle: number | null;
    _heroPendingTimer: ReturnType<typeof setTimeout> | null;
  } {
    return {
      carouselIndex: 0,
      heroBgUrl: "",
      carouselTimer: null,
      heroLoadGen: 0,
      _heroDestroyed: false,
      _heroPendingIdle: null,
      _heroPendingTimer: null,
    };
  },
  computed: {
    heroBg(): { backgroundImage: string } {
      const url = this.heroBgUrl || "none";
      return { backgroundImage: url === "none" ? "none" : `url(${url})` };
    },
  },
  watch: {
    carouselIndex(): void {
      this.loadHeroSlide();
    },
  },
  mounted(): void {
    this.loadHeroSlide();
    this.carouselTimer = setInterval(() => {
      this.carouselIndex = (this.carouselIndex + 1) % CAROUSEL_FILES.length;
    }, 5000);
  },
  beforeDestroy(): void {
    this._heroDestroyed = true;
    if (this.carouselTimer) clearInterval(this.carouselTimer);
    if (this._heroPendingIdle !== null) {
      try { cancelIdleCallback(this._heroPendingIdle); } catch { /* ignore */ }
      this._heroPendingIdle = null;
    }
    if (this._heroPendingTimer !== null) {
      clearTimeout(this._heroPendingTimer);
      this._heroPendingTimer = null;
    }
  },
  methods: {
    preloadImage(url: string): Promise<void> {
      return enqueueImageLoad(
        () =>
          new Promise<void>((resolve, reject) => {
            const img = new Image();
            img.onload = () => resolve();
            img.onerror = () => reject();
            img.src = url;
          })
      );
    },
    loadHeroSlide(): void {
      if (this._heroDestroyed) return;
      const idx = this.carouselIndex;
      const file = CAROUSEL_FILES[idx];
      const rel = carouselRelativePath(file);
      const thumbSrc = thumbUrl(rel);
      const fullSrc = assetUrl(rel);
      this.heroLoadGen += 1;
      const gen = this.heroLoadGen;

      this.heroBgUrl = "";

      this.preloadImage(thumbSrc)
        .then(() => {
          if (this._heroDestroyed || gen !== this.heroLoadGen || this.carouselIndex !== idx) {
            return;
          }
          this.heroBgUrl = thumbSrc;

          const upgrade = () => {
            if (this._heroDestroyed) return;
            this.preloadImage(fullSrc)
              .then(() => {
                if (this._heroDestroyed || gen !== this.heroLoadGen || this.carouselIndex !== idx) {
                  return;
                }
                this.heroBgUrl = fullSrc;
              })
              .catch(() => {
                /* 保留缩略图 */
              });
          };

          if (typeof requestIdleCallback === "function") {
            this._heroPendingIdle = requestIdleCallback(() => {
              this._heroPendingIdle = null;
              upgrade();
            }, { timeout: 6000 });
          } else {
            this._heroPendingTimer = setTimeout(() => {
              this._heroPendingTimer = null;
              upgrade();
            }, 500);
          }
        })
        .catch(() => {
          /* 保留空或上一张 */
        });
    },
  },
};
